export const environment = {
	production: false,
	apiUrl: 'https://api-managment-digitalizcija.azure-api.net/isbp-development/',
	AAD: {
		clientId: '21aa0ebf-3cd6-4030-a45c-5e64dbab0249',
		authority: 'https://login.microsoftonline.com/c7223f2c-1ba2-43c8-be7f-57e6e1465036',
		scope: 'api://de1cf3eb-e69b-4fd9-9029-6f76b1a4c7d6/All',
		redirectUri: 'https://victorious-sky-019956803.6.azurestaticapps.net',
		postLogoutRedirectUri: 'https://victorious-sky-019956803.6.azurestaticapps.net',
	},
	useApim: true,
	secret: '4832f02c7fcd44658fecdc7cbbce42be',
};
